import React from 'react';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import Base from './Base'

export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            menuOpen: 1,
            openMenu: ''
        }
    }
    componentDidMount() { 
        this.httpPost("api/v1/common/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return contents;
    }
    toggleMenu() {
        if (this.state.menuOpen == 1) this.setState({ menuOpen: 0 });
        else this.setState({ menuOpen: 1 });
    }
    hasPermission(p) {
        if (this.state.data.global.user.role === 1) return 1;
        if (this.state.data.global.user.permissions.includes('[' + p + ']')) return true;
        return false
    }
    renderForm() {
        return <div className={"nk-sidebar nk-sidebar-fixed is-dark " + (this.state.menuOpen == 1 ? "" : "is-compact")} id="sideBarMenu" data-content="sidebarMenu">
            <div className="nk-sidebar-element nk-sidebar-head">
                <div className="nk-menu-trigger" onClick={e => this.toggleMenu()}>
                    <a className="nk-nav-toggle nk-quick-nav-icon d-xl-none" data-target="sidebarMenu"><em className="icon ni ni-arrow-left"></em></a>
                    <a className="nk-nav-compact nk-quick-nav-icon d-none d-xl-inline-flex" data-target="sidebarMenu"><em className="icon ni ni-menu"></em></a>
                </div>
            </div>
            <div className="nk-sidebar-element nk-sidebar-body">
                <div className="nk-sidebar-content">
                    <div className="nk-sidebar-menu" data-simplebar>
                        <ul className="nk-menu">
                            <li className="nk-menu-item">
                                <Link to="/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-home"></em></span>
                                    <span className="nk-menu-text">داشبرد</span>
                                </Link>
                            </li>
                            {this.hasPermission('applicants') && <li className="nk-menu-item">
                                <Link to="/applicants/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-menu-circled"></em></span>
                                    <span className="nk-menu-text">مشتریان</span>
                                </Link>
                            </li>}
                            {(this.state.data.global.user.role <= 2 || this.state.data.global.user.role === 3) &&
                                <li class={"nk-menu-item has-sub " + (this.state.openMenu == "stone" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.setState({ openMenu: this.state.openMenu === "stone" ? "" : 'stone' })}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-menu-circled"></em></span>
                                        <span className="nk-menu-text">شناسنامه های سنگ</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.state.data.global.stoneTemplates.map(item=>
                                            <li className="nk-menu-item">
                                                <a href={"/stones/" + item.id + "/"} className="nk-menu-link">
                                               <span className="nk-menu-text">{item.title}</span>
                                            </a>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            }
                            {(this.state.data.global.user.role <= 2 || this.state.data.global.user.role === 4) &&
                                <li class={"nk-menu-item has-sub " + (this.state.openMenu == "lux" ? "active" : "")}>
                                    <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.setState({ openMenu: this.state.openMenu === "lux" ? "" : 'lux' })}>
                                        <span className="nk-menu-icon"><em className="icon ni ni-menu-circled"></em></span>
                                        <span className="nk-menu-text">شناسنامه های فاخر</span>
                                    </a>
                                    <ul className="nk-menu-sub">
                                        {this.state.data.global.luxTemplates.map(item =>
                                            <li className="nk-menu-item">
                                                <a href={"/luxurious/" + item.id + "/"} className="nk-menu-link">
                                                    <span className="nk-menu-text">{item.title}</span>
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            }
                            {this.hasPermission('requests') && <li className="nk-menu-item">
                                <Link to="/requests/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-menu-circled"></em></span>
                                    <span className="nk-menu-text">درخواست شناسنامه</span>
                                </Link>
                            </li>}
                            <li class={"nk-menu-item has-sub " + (this.state.openMenu == "base" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.setState({ openMenu: this.state.openMenu === "base" ? "" : 'base' })}>
                                    <span className="nk-menu-icon"><em className="icon ni ni-grid-alt"></em></span>
                                    <span className="nk-menu-text">اطلاعات پایه</span>
                                    <span class="nk-menu-badge" id="navmenu_mgr" style={{ "display": "none" }}>0</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    {this.hasPermission('templates') && <li className="nk-menu-item">
                                        <Link to="/templates/" className="nk-menu-link">
                                            <span className="nk-menu-text">الگوهای شناسنامه</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('colors') && <li className="nk-menu-item">
                                        <Link to="/colors/" className="nk-menu-link">
                                            <span className="nk-menu-text">رنگها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('sizes') && <li className="nk-menu-item">
                                        <Link to="/sizes/" className="nk-menu-link">
                                            <span className="nk-menu-text">ابعاد</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('weights') && <li className="nk-menu-item">
                                        <Link to="/weights/" className="nk-menu-link">
                                            <span className="nk-menu-text">وزنها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('kinds') && <li className="nk-menu-item">
                                        <Link to="/kinds/" className="nk-menu-link">
                                            <span className="nk-menu-text">انواع تراش</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('types') && <li className="nk-menu-item">
                                        <Link to="/types/" className="nk-menu-link">
                                            <span className="nk-menu-text">انواع سنگ</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('stufftypes') && <li className="nk-menu-item">
                                        <Link to="/stufftypes/" className="nk-menu-link">
                                            <span className="nk-menu-text">انواع کالاها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('jenses') && <li className="nk-menu-item">
                                        <Link to="/jenses/" className="nk-menu-link">
                                            <span className="nk-menu-text">جنس کالاها</span>
                                        </Link>
                                    </li>}
                                    {this.hasPermission('rings') && <li className="nk-menu-item">
                                        <Link to="/rings/" className="nk-menu-link">
                                            <span className="nk-menu-text">سایز رینگ</span>
                                        </Link>
                                    </li>}
                                </ul>
                            </li>
                            {this.hasPermission('websites') && <li className="nk-menu-item">
                                <Link to="/websites/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-link"></em></span>
                                    <span className="nk-menu-text">وبسایتها</span>
                                </Link>
                            </li>}
                            {this.hasPermission('users') && <li className="nk-menu-item">
                                <Link to="/users/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-users"></em></span>
                                    <span className="nk-menu-text">کاربران</span>
                                </Link>
                            </li>}
                            {this.hasPermission('settings') && <li className="nk-menu-item">
                                <Link to="/settings/" className="nk-menu-link">
                                    <span className="nk-menu-icon"><em className="icon ni ni-setting"></em></span>
                                    <span className="nk-menu-text">تنظیمات</span>
                                </Link>
                            </li>}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    }
}